import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3e6d1cb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { computed } from 'vue';
import ComputeWizardStepContainer from '@/components/ComputeWizard/ComputeWizardStepContainer.vue';
import DropdownSelect from '@/components/DropdownSelect.vue';
import SegmentSelect from '@/components/SegmentSelect.vue';
import useTranslateEnums from '@/composables/useTranslateEnums';
import { SizeUnit, SizeTypeImperial, SizeTypeMetric } from '@/enums/Size';
import { useSizeStepStore } from '@/store/sizeStep';
import {
  defaultSizePitchValue,
  imperialValues,
  metricValues,
  SizeMetricValue,
  SizeImperialValue,
} from '@/data/SizeValues';
import { TranslateElement } from '@/types/TranslateElement';
import Size from '@/assets/images/step-schemas/size-and-pitch.png';


export default /*#__PURE__*/_defineComponent({
  __name: 'ComputeWizardSize',
  setup(__props) {

const { translate } = useTranslateEnums();
const sizeStepStore = useSizeStepStore();

const metricUnits = computed((): Array<TranslateElement> => {
  return translate(SizeTypeMetric, 'size.weight');
});

const imperialUnits = computed((): Array<TranslateElement> => {
  return translate(SizeTypeImperial, 'size.weight');
});

// Units

const units = computed((): Array<TranslateElement> => {
  return translate(SizeUnit, 'size.units');
});

// Weights
const weights = computed(() => {
  return sizeStepStore.unit === SizeUnit.Metric ? metricUnits.value : imperialUnits.value;
});

// Sizes
const sizeOptions = computed(() => {
  let values: Array<SizeMetricValue | SizeImperialValue> =
    sizeStepStore.unit === SizeUnit.Metric ? metricValues : imperialValues;

  values = values
    .filter((item: any) => {
      return item.pitch[sizeStepStore.type] !== undefined;
    })
    .sort((a: any, b: any) => {
      return a.value - b.value;
    });

  return values.map((item: any) => {
    item.label = item.key;
    return item;
  });
});

const onSelectChange = () => {
  if (
    sizeStepStore.unit === SizeUnit.Metric &&
    (sizeStepStore.type === SizeTypeMetric.Big || sizeStepStore.type === SizeTypeMetric.Slim)
  ) {
    sizeStepStore.setSize(defaultSizePitchValue);
    return;
  }

  if (sizeOptions.value && sizeOptions.value[0]) {
    sizeStepStore.setSize(sizeOptions.value[0].value);
  }
};

const onSizeSelectChange = () => {
  if (sizeStepStore.unit === SizeUnit.Metric) {
    sizeStepStore.setType(SizeTypeMetric.Big);
  } else {
    sizeStepStore.setType(SizeTypeImperial.UNC);
  }

  onSelectChange();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ComputeWizardStepContainer, { class: "compute-wizard-size" }, {
    default: _withCtx(() => [
      _createVNode(SegmentSelect, {
        onOnChange: onSizeSelectChange,
        class: "compute-wizard-size__size",
        modelValue: _unref(sizeStepStore).unit,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(sizeStepStore).unit) = $event)),
        options: units.value
      }, null, 8, ["modelValue", "options"]),
      _createVNode(SegmentSelect, {
        onOnChange: onSelectChange,
        class: "compute-wizard-size__pitch-type",
        modelValue: _unref(sizeStepStore).type,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(sizeStepStore).type) = $event)),
        options: weights.value
      }, null, 8, ["modelValue", "options"]),
      _createVNode(DropdownSelect, {
        class: "compute-wizard-size__pitch",
        label: _ctx.$t('size.type_input_label'),
        modelValue: _unref(sizeStepStore).size,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(sizeStepStore).size) = $event)),
        options: sizeOptions.value
      }, null, 8, ["label", "modelValue", "options"]),
      _createElementVNode("img", {
        class: "compute-wizard-size__image",
        src: _unref(Size)
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})